import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { resources } from './locales';

i18n

  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,

    supportedLngs: ['pt', 'en', 'de'],
    fallbackLng: 'pt',

    detection: {
      order: ['cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['cookie', 'localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
